// src/components/Enrollments/api/enrollmentsApi.js
// ============================================================================
// BLOCK ENR.API.0 — Enrollments API helpers
// ----------------------------------------------------------------------------
// PURPOSE
//  - Keep all HTTP requests for the Enrollments page in one place.
//  - Mirror the axios pattern already used in the React project.
// ============================================================================

import axios from '../../../axiosClient.js';

function getEnrollmentsUrl(selectedRep) {
  if (!selectedRep || selectedRep === 'all-reps') {
    return '/api/enrollments/all-reps';
  }

  return `/api/enrollments/${encodeURIComponent(selectedRep)}`;
}

export async function fetchEnrollments({
  selectedRep,
  selectedYear,
  page,
  rowsPerPage,
  customerSearch,
  repSearch,
  productTypeSearch,
}) {
  const { data } = await axios({
    method: 'GET',
    url: getEnrollmentsUrl(selectedRep),
    params: {
      year: selectedYear,
      limit: rowsPerPage,
      offset: page * rowsPerPage,
      customerSearch,
      repSearch,
      productTypeSearch,
    },
  });

  return data;
}

export async function exportEnrollmentsCsv({
  selectedRep,
  selectedYear,
  customerSearch,
  repSearch,
  productTypeSearch,
}) {
  const response = await axios({
    method: 'GET',
    url: getEnrollmentsUrl(selectedRep),
    params: {
      year: selectedYear,
      customerSearch,
      repSearch,
      productTypeSearch,
    },
    headers: {
      Accept: 'text/csv',
    },
    responseType: 'blob',
  });

  const contentDisposition = response.headers['content-disposition'] || '';
  const match = contentDisposition.match(/filename="?([^";]+)"?/i);
  const filename = match?.[1] || `enrollments-${selectedYear}.csv`;

  const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
